import { authorizedGet } from '../utils/api';
import { STRIPO_TOKEN } from '../constants/api';

class StripoService {
  static getStripoToken = token => authorizedGet(STRIPO_TOKEN, token, {});
}

export default StripoService;
